import DisburseLoan from "./DisburseLoan.jsx";

export default DisburseLoan;
